import debug from 'shared/debug'
import 'whatwg-fetch'

export class JSONFetcher {
  static load({ url, success, signal = undefined}) {
    fetch(url, {signal: signal})
      .then(response => response.json())
      .then(json     => success(json))
      .then(undefined, err => debug(err))
  }

  static post(opts) {
    this.submit({method: 'post', ...opts})
  }

  static put(opts) {
    this.submit({method: 'put', ...opts})
  }

  static delete(opts) {
    this.submit({method: 'delete', ...opts})
  }

  static submit({method, url, jsonObject, success, signal = undefined}) {
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    const jsonString = JSON.stringify(jsonObject)

    fetch(url, {
      method:      method,
      headers:     { 'Content-Type': 'application/json', 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest' },
      body:        jsonString,
      credentials: 'same-origin',
      signal:      signal
    }).then(response => response.json())
      .then(json     => success(json))
      .then(undefined, err => debug(err))
  }
}

export const jsonFetch = (url, options) => {
  options.credentials = 'same-origin'
  options.headers = {
    'Content-Type':     'application/json',
    'Accept':           'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token':     document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
  options.body = JSON.stringify(options.body)

  return fetch(url, options)
}
